import "@arco-design/web-react/es/Radio/style";
import _Radio from "@arco-design/web-react/es/Radio";
import React from 'react';
export function RadioGroup({
  onChange,
  value,
  id,
  field,
  name
}) {
  const item = field?.values?.find(item => item.value === id) || {};
  return /*#__PURE__*/React.createElement(_Radio.Group, {
    value: value,
    disabled: field.disabled,
    onChange: event => onChange?.(event, field, name)
  }, /*#__PURE__*/React.createElement(_Radio, {
    value: item?.label
  }));
}